<template>
  <div>
    <VMSMenuTop />
    <VMSMap />
    <br>
    <VMSStatistics />
    <br>
    <VMSChart />
    <Card-VMS />
    <br>
    <VMSTable />
  </div>
</template>

<script>
import VMSMap from '@/views/vms/total/VMSMap.vue'
import VMSStatistics from '@/views/vms/total/VMSStatistics.vue'
import VMSTable from '@/views/vms/total/VMSTable.vue'
import VMSMenuTop from '@/views/vms/total/VMSMenuTop.vue'
import VMSChart from '@/views/vms/total/VMSChart.vue'
import CardVMS from '@/views/vms/total/VMSVideo.vue'
// import axios from '@axios'
export default {
  components: {
    VMSMap,
    VMSStatistics,
    CardVMS,
    VMSTable,
    VMSMenuTop,
    VMSChart,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
